export enum CustomerTypes {
  MAJOR_CUSTOMERS = 'MAJOR_CUSTOMERS',
  HOUSING_INDUSTRY = 'HOUSING_INDUSTRY',
  BUSINESS = 'BUSINESS'
}

export const parseCustomerType = (type: CustomerTypes | string = CustomerTypes.BUSINESS) => {
  switch (type) {
    case CustomerTypes.MAJOR_CUSTOMERS:
      return 'Großkunden';
    case CustomerTypes.HOUSING_INDUSTRY:
      return 'Wohnungswirtschaft';
    default:
    case CustomerTypes.BUSINESS:
      return 'Gewerbekunden';
  }
}
